import { BrowserRouter, Route, Routes } from "react-router-dom";
import Anon from "./Anon/Anon";
import Login from "./AssignmentsScreen/Assignments";
import Consent from "./ConsentScreen/Consent";
import DoutoradoSelectCollectionScreen from "./DoutoradoSelectCollectionScreen/DoutoradoSelectCollectionScreen";
import Finish from "./FinishScreen/Finish";
import GenericAnon from "./GenericAnon/GenericAnon";
import Instructions from "./InstructionsScreen/Instructions";
import ParceirosSelectYear from "./ParceirosSelectYearScreen/ParceirosSelectYear";
import Questions from "./QuestionsScreen/Questions";
import Redirect from "./RedirectScreen/Redirect";
import SeducSelectYear from "./SeducSelectYearScreen/SeducSelectYear";
import SelfInvite from "./SelfInvite/SelfInvite";

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/auth" element={<Redirect />} />
        <Route path="/invite" element={<SelfInvite />} />
        <Route path="/genericAnon" element={<GenericAnon />} />
        <Route path="/anon" element={<Anon />} />
        <Route path="/seducSelect" element={<SeducSelectYear />} />
        <Route path="/parceirosSelect" element={<ParceirosSelectYear />} />
        <Route
          path="/doutoradoSelect"
          element={<DoutoradoSelectCollectionScreen />}
        />
        <Route path="/instructions/:assignmentId" element={<Instructions />} />
        <Route path="/instrument/consent" element={<Consent />} />
        <Route path="/instrument/questions" element={<Questions />} />
        <Route path="/instrument/end" element={<Finish />} />
      </Routes>
    </BrowserRouter>
  );
}
